<template>
    <Paper class="checkSearch">
        <span class="page-description">条码盘点导入查询</span>
        <i class="page-description-question el-icon-question" :data-title="pageDescription"></i>
        <div class="processSearch">
            <el-row type="flex" class="row-bg" justify="space-between">
                <el-col class="checkSearch-search-left">
                    <el-row>
                        <el-col class="checkSearch-tiem">
                            <el-input v-model="searchData['customerCode']" :placeholder="$translate('lang.E3202102220011', { defaultText: '客户编码' })"></el-input>
                        </el-col>
                        <el-col class="checkSearch-tiem">
                            <el-input v-model="searchData['barcodeNo']" :placeholder="$translate('lang.E3202102220012', { defaultText: '条码' })"></el-input>
                        </el-col>
                        <el-col class="checkSearch-tiem">
                            <el-input v-model="searchData['prodCode']" :placeholder="$translate('lang.E3202102220013', { defaultText: '产品编码' })"></el-input>
                        </el-col>
                        <el-col class="checkSearch-tiem">
                            <el-input v-model="searchData['prodName']" :placeholder="$translate('lang.E3202102220014', { defaultText: '产品描述' })"></el-input>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col class="checkSearch-search-right">
                    <div class="processSearch-search">
                        <div class="search-margin">
                            <el-button type="primary" :loading="searchLoading" size="mini" @click="searchChange" icon='el-icon-search'>
                                {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                            </el-button>
                            <el-button class="sn-search-reset-button" @click="restSearchChange" size="mini">
                                {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                            </el-button>
                        </div>
                        <div @click="changeSecondQueryCondition" class="packUP">
                            <span>{{isCloseText}}</span>
                            <span v-if="showSecondQueryCondition">
                                <i class="el-icon-arrow-up"></i>
                            </span>
                            <span v-else>
                                <i class="el-icon-arrow-down"></i>
                            </span>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row v-if="showSecondQueryCondition">
                <el-col class="checkSearch-search-left">
                    <el-row>
                        <el-col class="checkSearch-tiem" :span="8" v-for="(listItem,index) in searchList" :key='index'>
                            <div class='item'>
                                <div class="search-code">
                                    <el-date-picker v-if="listItem.type === 'date'" v-model="searchData[listItem.value]" align="left" value-format='yyyy-MM-dd HH:mm:ss' unlink-panels size="mini"
                                        type="daterange" range-separator="-" :start-placeholder="$translate('lang.E3202101270023', { defaultText: '开始日期' })"
                                        :end-placeholder="$translate('lang.E3202101270024', { defaultText: '结束日期' })" :picker-options="pickerOptions" :default-time="['00:00:00', '23:59:59']">
                                    </el-date-picker>
                                    <el-input :id="listItem.ref" v-else-if="listItem.type === 'input' " v-model="searchData[listItem.value]" :placeholder="listItem.placeholder">
                                    </el-input>

                                    <el-select v-else-if="listItem.type === 'select'" v-model="searchData[listItem.value]" :placeholder="listItem.placeholder" :clearable="listItem.clearable">
                                        <el-option v-for="item in listItem.options" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div class="btnList">
            <mExport :url='listExport.exportUrl' :params='listExport.exportParams' :name='listExport.exportName' :type='listExport.type' :listData='listData' :exportFlag='listExport.exportFlag'
                :titleText='listExport.titleText'>
            </mExport>
            <el-button type="primary" :loading="deleteLoading" size="mini" @click="deleteLots">
                {{$translate('lang.E3202102220025', { defaultText: '批量删除' })}}
            </el-button>
        </div>
        <div :class="isCloseFlag">
            <m-table ref="RegistrationTable" :pageTotal="pageTotal" :tableData="listData" :currentPage='currentPage' @onSelectionChange='onSelectionChange' @btn-event='btnEventByDetail'
                @pageChange="pageChange" @sizeChange="sizeChange" :config="tableConfig">
            </m-table>
        </div>
    </Paper>
</template>
<script>
import { allChecklist, allCheckdelete } from '../../../api/lcbsManagement.js';
import Paper from '@/components/core/paper/Paper';
import mTable from '../../../components/IdentityComponent/Main';
import { tableConfig } from './tableConfig.js';
import { searchListConfig } from './searchList.js';
import mExport from '../component/export';
import formatTime from '@/utils/common.js';
import { dictWithUrl } from '../../../components/basicDataDialog/api';
import { getDictionaryDetail } from '../../../api/systemManagementApi.js';
import store from '@/store/index';
export default {
    name: 'checkSearch',
    components: { Paper, mTable, mExport },
    data() {
        return {
            checkFirstTime: true,
            searchList: searchListConfig.searchList,
            tableConfig,
            searchData: {},
            searchLoading: false,
            listData: [],
            pageTotal: 0,
            currentPage: 1,
            showSecondQueryCondition: false,
            isCloseText: this.$translate('lang.E3202101280014', { defaultText: '展开' }),
            isCloseFlag: 'closeStyle',
            selectList: [],
            listExport: {
                exportUrl: '/api-sn/lbcs/bcBarcodeCheckDtls/export',
                exportName: this.$translate('lang.E3202102220026', { defaultText: '条码盘点导入所有查询.xls' }),
                exportParams: {},
                titleText: this.$translate('lang.E3202102220027', { defaultText: '导出Excel' }),
                exportFlag: 0
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: this.$translate('lang.E3202101270017', { defaultText: '最近一周' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(6), formatTime.initEndDate()]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270019', { defaultText: '最近一个月' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(30), formatTime.initEndDate()]);
                        }
                    }
                ]
            },
            pageDescription: '',
            deleteLoading: false,
            permissionLimit: false
        };
    },
    methods: {
        elOperator() {
            if (this.permissionLimit) {
                this.$nextTick(() => {
                    const el = document.getElementById('uploadPerson');
                    el.disabled = true;
                    el.parentElement.className += ' is-disabled';
                });
            }
        },
        checkUserPermission() {
            if (this.checkFirstTime === false) {
                this.elOperator();
                return;
            }
            const params = {
                dictCode: 'USER_ROLE',
                pageNo: 1,
                pageSize: 1000
            };
            getDictionaryDetail(params).then(res => {
                this.checkFirstTime = false;
                if (res.code === '0') {
                    const userCode = store.getters.user.userCode;
                    const userExist = res.data.list.filter((item) => {
                        return item.code === userCode && item.enableFlag === 1;
                    });
                    if (userExist.length > 0) {
                        this.permissionLimit = true;
                        this.inputCheckDisable = true;
                        this.searchData.creationBy = userExist[0].code;
                        if (this.showSecondQueryCondition) {
                            this.elOperator();
                        }
                    }
                }
            });
        },
        initData(isrest) {
            this.searchData = {
                customerCode: '',
                barcodeNo: '',
                prodCode: '',
                prodName: '',
                creationBy: this.searchData.creationBy,
                uploadTime: [formatTime.formatDate(formatTime.initStartDate(6)) + ' 00:00:00',
                formatTime.formatDate(formatTime.initEndDate()) + ' 23:59:59'],
                runFlag: '',
                barCheckInvaildCode: '',
                reuploadFlag: '',
                salescenterCode: '',
                parCustomerCode: '',
                batchId: '',
                activeFlag: '',
                remark: '',
                queryType: 'all'
            };
            if (!isrest) {
                this.listData = [];
            };
        },
        restSearchChange() {
            this.initData(true);
            this.elOperator();
            this.templateFlie = {};
            this.listExport.exportFlag = 0;
        },
        changeSecondQueryCondition() {
            this.showSecondQueryCondition = !this.showSecondQueryCondition;
            if (this.showSecondQueryCondition) {
                this.isCloseText = this.$translate('lang.E3202101280015', { defaultText: '收起' });
                this.isCloseFlag = 'openStyle';
                // this.checkUserPermission();
                this.elOperator();
            } else {
                this.isCloseText = this.$translate('lang.E3202101280014', { defaultText: '展开' });
                this.isCloseFlag = 'closeStyle';
            }
        },
        handleSearchData() {
            const params = {
                ...this.searchData,
                pageNo: this.tableConfig.page.pageNo,
                pageSize: this.tableConfig.page.pageSize
            };
            if (params.uploadTime) {
                params['startTime'] = params['uploadTime'][0];
                params['endTime'] = params['uploadTime'][1];
                delete params.uploadTime;
            };
            delete params.uploadTime;
            Object.keys(params).forEach(item => {
                if (!params[item]) {
                    delete params[item];
                }
            });
            return params;
        },
        searchChange() {
            // if (!this.searchData.customerCode && !this.searchData.barcodeNo && !this.searchData.creationBy && !this.searchData.uploadTime) {
            //     this.$message.warning(this.$translate('lang.EXC202002220006', { defaultText: '至少输入一项查询条件：客户编码、条码、上传人、上传时间' }));
            //     return;
            // }
            if (!this.searchData.creationBy && !this.searchData.batchId) {
                this.$message.warning(this.$translate('lang.EXC202207270001', { defaultText: '上传人、批次号不能同时为空' }));
                return;
            }

            this.tableConfig.page.pageNo = 1;
            this.currentPage = 1;
            this.listExport.exportParams = this.handleSearchData();
            this.getData(this.listExport.exportParams);
        },
        getData(params, deleteTag = false) {
            if (deleteTag) {
                this.deleteLoading = true;
            } else {
                this.searchLoading = true;
            }
            allChecklist(params).then(res => {
                if (res.code === '0') {
                    this.listData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                    this.listExport.exportFlag = 1;
                }
            }).finally(() => {
                if (deleteTag) {
                    this.deleteLoading = false;
                } else {
                    this.searchLoading = false;
                }
            });
        },
        btnEventByDetail(data, event) {
            switch (event) {
                case 'delete':
                    this.$confirm(this.$translate('lang.EXC202002220007', { defaultText: '此操作将删除选中数据, 是否继续' }),
                        this.$translate('lang.E3202102220028', { defaultText: '提示' }), {
                        confirmButtonText: this.$translate('lang.E3202101270001', { defaultText: '确定' }),
                        cancelButtonText: this.$translate('lang.E3202101270002', { defaultText: '取消' }),
                        type: 'warning'
                    }).then(() => {
                        allCheckdelete([data.bcBarcodeCheckId]).then(res => {
                            this.$message.success(this.$translate('lang.EXC202102230001', { defaultText: '删除成功！' }));
                            const params = this.handleSearchData();
                            this.getData(params);
                        });
                    });
                    break;
                default:
                    break;
            }
        },
        onSelectionChange(rowArr) {
            this.selectList = [];
            rowArr.map(item => {
                this.selectList.push(item.bcBarcodeCheckId);
            });
        },
        deleteLots() {
            if (this.selectList.length < 2) {
                this.$message.warning(this.$translate('lang.EXC202002220008', { defaultText: '请选择两条以上的数据' }));
                return;
            }
            this.$confirm(
                this.$translate('lang.EXC202002220007', { defaultText: '此操作将删除选中数据, 是否继续' }),
                this.$translate('lang.E3202102220028', { defaultText: '提示' }),
                {
                    confirmButtonText: this.$translate('lang.E3202101270001', { defaultText: '确定' }),
                    cancelButtonText: this.$translate('lang.E3202101270002', { defaultText: '取消' }),
                    type: 'warning'
                }).then(() => {
                    this.deleteLoading = true;
                    allCheckdelete(this.selectList).then(res => {
                        this.$message.success(this.$translate('lang.EXC202102230001', { defaultText: '删除成功！' }));
                        const params = this.handleSearchData();
                        this.getData(params, true);
                    }).finally(() => {
                        this.deleteLoading = false;
                    });
                });
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.currentPage = pageNo;
            const params = this.handleSearchData();
            this.getData(params);
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.currentPage = 1;
            this.tableConfig.page.pageSize = pageSize;
            const params = this.handleSearchData();
            this.getData(params);
        },
        async dictData() {
            const option = await dictWithUrl('BILL_DESC');// BILL_DESC-菜单描述
            const dictOptions = {};
            if (+option.code === 0) {
                const dictList = option.data.BILL_DESC;
                dictList.forEach(item => {
                    dictOptions[item.code] = item.name;
                });
            }
            this.pageDescription = dictOptions[this.$options.name].replace(/ {2}/g, '\n');
        }
    },
    async created() {
        await this.dictData();
    },
    mounted() {
        this.initData();
        this.checkUserPermission();
    }
};
</script>
<style lang="less" src='./index.less'>
</style>
